import { html } from "lit-html"
import { virtual, useState } from "haunted"
import ButtonForm from "../forms/button"
import DateTime from "./date-time"
import CalLinks from "./cal-links"
import Location from "./location"
import SocialLinks from "./social-links"
import TypesList from "./types-list"
import ActionMenu from "../generic/action-menu"
import { keyClickWrapper } from "../utils"
import markdown from "../utils/markdown"
import EventRegButtonForm from "../forms/event-reg"

import {
  CANCEL_PATH,
  EDIT_PATH,
  DELETE_PATH,
  REGISTER_PATH,
} from "../constants"

const WorkshopRow = virtual(
  ({
    id,
    name,
    types,
    url,
    date,
    start_time,
    shortened_timezone,
    recurring_pattern,
    recurring_patterns,
    description,
    remote,
    link,
    location,
    program,
    can_edit,
    can_delete,
    can_register,
    can_cancel_registration,
    can_see_checked_in,
    gcal_link,
  }) => {
    const [expanded, setExpanded] = useState(false)

    return html`
      <div
        class="workshop group filter-result-row"
        role="button"
        tabindex="0"
        @click=${() => setExpanded(!expanded)}
        @keydown=${(e) => keyClickWrapper(e, () => setExpanded(!expanded))}
        aria-controls=${`item-${id}`}
        aria-expanded=${expanded.toString()}
      >
        <div class="w-3/4 lg:w-1/3 p-3 order-1">
          <p>
            <span
              class="text-blue group-hover:text-black group-focus:text-gray-dark group-focus:font-bold"
              >${name}</span
            >
          </p>
          <p>${TypesList(types)}</p>
        </div>
        <div class="w-3/4 lg:w-1/3 p-3 order-3 lg:order-2">
          ${DateTime({ start_date: date, start_time, shortened_timezone })}
          ${recurring_patterns.map(
            (pattern) =>
              html`<p
                class="italic ${pattern.id === recurring_pattern
                  ? "font-bold"
                  : ""}"
              >
                * ${pattern.name}
              </p>`
          )}
        </div>
        <div
          class="w-1/4 lg:w-1/6 p-3 order-4 lg:order-3 text-right lg:text-left"
        >
          ${program ? program.name : ``}
        </div>
        <div
          class="flex flex-row items-center justify-end w-1/4 lg:w-1/6 p-3 order-2 lg:order-4 text-right"
        >
          ${ActionMenu({
            children: html`
              ${can_edit
                ? html`
                    <a
                      class="dropdown-item"
                      role="menuitem"
                      href="${url}${EDIT_PATH}"
                    >
                      Edit workshop
                    </a>
                  `
                : ""}
              ${can_delete
                ? html`
                    <a
                      class="dropdown-item"
                      role="menuitem"
                      href="${url}${DELETE_PATH}"
                    >
                      Delete workshop
                    </a>
                  `
                : ""}
              <a class="dropdown-item" role="menuitem" href=${url}>
                View workshop details
              </a>
              ${CalLinks({ url, gcal_link })} ${SocialLinks({ url })}
            `,
          })}
        </div>
        <hr class="divider m-3 mb-0 order-10" />
      </div>
      <div
        class="collapse-row py-1"
        id=${`item-${id}`}
        aria-hidden=${(!expanded).toString()}
      >
        ${expanded
          ? html`
              <div class="p-5 max-w-570">
                <div class="content mb-6">
                  ${Location({ location, link, remote })}
                  ${description
                    ? markdown(description)
                    : html`<p>No description available</p>`}
                </div>
                ${can_register
                  ? EventRegButtonForm({
                      action: `${url}${REGISTER_PATH}`,
                      title: "Register for workshop",
                      className: "mb-4",
                    })
                  : ``}
                ${can_cancel_registration
                  ? ButtonForm({
                      url: `${url}${CANCEL_PATH}`,
                      label: "Cancel registration for workshop",
                      buttonClass: "button button-submit mb-4",
                    })
                  : ``}
                ${can_see_checked_in
                  ? html`
                      <div
                        class="inline-flex items-center justify-center text-sm min-h-9 min-w-240 rounded bg-gray-bg mb-4"
                      >
                        You checked in to this workshop.
                      </div>
                    `
                  : ""}
                <a
                  class="flex items-center justify-center h-10 w-full bg-blue text-white rounded hover:bg-blue-dark focus:bg-blue-dark"
                  data-link="details"
                  href=${url}
                >
                  View full workshop details
                </a>
              </div>
            `
          : ""}
      </div>
    `
  }
)

export default WorkshopRow
